import React from "react";
import { Pane } from "components/base/layout";
import { UIProps } from "components/base/types";

export const Code = (props: UIProps) => (
  <Pane is="code" color="#171E26" {...props} />
);
